import { useMutation, UseMutationHook } from 'redux-query-react';
import { getHeaders } from '../helpers/request/getHeaders';
import { handleUnauthorized } from '../helpers/request/handleUnauthorized';

export const useMutationWithAuth: UseMutationHook = (createQueryConfig) => useMutation((...args: any[]) => {
    const config = createQueryConfig(...args);
    return {
        ...config,
        options: {
            ...config.options,
            headers: getHeaders(),
        },
        transform: (response: any, { error }: ErrorEvent) => {
            if (error) {
                handleUnauthorized();
            }
            return config.transform ? config.transform(response, error) : response;
        },
    };
});
